import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { FaExclamationTriangle } from 'react-icons/fa';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorInfo: null };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            errorInfo: errorInfo
        });
        
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <motion.div 
                    className="error-boundary"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                >
                    <div className="error-content">
                        <FaExclamationTriangle className="error-icon" />
                        <h2>Oups ! Quelque chose s&apos;est mal passé</h2>
                        <p>Une erreur inattendue s&apos;est produite. Veuillez rafraîchir la page.</p>
                        <button 
                            onClick={() => window.location.reload()}
                            className="error-button"
                        >
                            Rafraîchir la page
                        </button>
                    </div>
                </motion.div>
            );
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired
};

export default ErrorBoundary; 